import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import axios from 'axios';
import { LIST_PAYMENT_PROOFS_API, get_headers } from '@/utils/constants/constants';

// Helper function to sanitize keys and prevent object injection
const sanitize_key = (key) => {
  if (typeof key !== 'string') {
    return 'invalid_key';
  }
  // Remove any characters that could be used for injection and add safe prefix
  const sanitized = key.replace(/[^a-zA-Z0-9_-]/g, '_');
  return `safe_${sanitized}`;
};

// Helper function to safely access object properties using Reflect
const safe_get_property = (obj, key) => {
  const sanitized_key = sanitize_key(key);
  return Reflect.get(obj, sanitized_key);
};

// Helper function to safely set object properties using Reflect
const safe_set_property = (obj, key, value) => {
  const sanitized_key = sanitize_key(key);
  Reflect.set(obj, sanitized_key, value);
};

export default {
  name: 'ProofOfPayment',
  components: { GlobalTable },
  data: () => ({
    preview_url: '',
    current_proof_url: '',
    payment_history: [],
    document_urls: {},
    lead_id: null,
    loading: false,
  }),
  async mounted() {
    this.lead_id =
      this.$route.params.lead_id || this.$route.query.lead_id || null;
    await this.fetch_proof_of_payments();
  },
  methods: {
    async fetch_proof_of_payments() {
  this.loading = true;
  try {
    const headers = get_headers();
    const params = this.lead_id ? { lead_id: this.lead_id } : {};
    const response = await axios.get(LIST_PAYMENT_PROOFS_API, { headers, params });

    if (response.data.status === 'success') {
      this.payment_history = [];
      this.document_urls = {};

      this.payment_history = response.data.data.map((item) => {
        const reference = item.reference || `Proof-${item.id}`;
        const document_name = item.document
          ? item.document.split('/').pop()
          : 'No Document';

        // Save URL for preview/open
        safe_set_property(this.document_urls, reference, item.document_url);

        return {
          'Payment Date': item.date_uploaded
            ? new Date(item.date_uploaded).toLocaleDateString()
            : '-',
          'Amount': item.amount_paid
            ? `R ${parseFloat(item.amount_paid).toFixed(2)}`
            : 'Pending Approval',
          'Reference': reference,
          'Document': document_name,
        };
      });

    } else {
      this.show_error(response.data.message || 'Failed to fetch payment proofs');
    }
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch payment proofs';
    this.show_error(message);
  } finally {
    this.loading = false;
  }
}
,

    preview_proof(row) {
      const reference = row.Reference || row.Reference;
      // Use safe property access to prevent object injection
      const document_url = safe_get_property(this.document_urls, reference);

      if (document_url) {
        this.current_proof_url = document_url;
      } else {
        this.show_error('No document available to preview.');
        this.current_proof_url = null;
      }
    },

    open_document(row) {
      const reference = row.Reference || row.Reference;
      // Use safe property access to prevent object injection
      const document_url = safe_get_property(this.document_urls, reference);

      if (document_url) {
        window.open(document_url, '_blank');
      } else {
        this.show_error('Document not found.');
      }
    },
  },
};